const extractWebrtcPlay = (state) => state?.webrtcPlay || [];

export const getWebrtcSettingByStream = (currentState, targetStreamName) => {
	const webrtcSettings = extractWebrtcPlay(currentState);

	const matchingSetting = webrtcSettings
		? webrtcSettings.find((setting) => setting.streamName === targetStreamName)
		: undefined;

	return matchingSetting || undefined;
};

export const getWebrtcSettingByStreamAndValue = (currentState, targetStreamName, targetPropertyValue) => {
	const webrtcSettings = extractWebrtcPlay(currentState);

	const matchingSetting = webrtcSettings
		? webrtcSettings.find((setting) => setting.streamName === targetStreamName)
		: undefined;

	if (matchingSetting) {
		const propertyValue = matchingSetting[targetPropertyValue];

		if (propertyValue !== undefined) {
			return propertyValue;
		} else {
			return null; // Return false if the specified property is not found in the setting
		}
	} else {
		return null; // Return false if no matching setting is found for the given stream name
	}
};
